<div class="tag label-x-sm" [style.background]="bgColor" [style.color]="textColor" [style.border-color]="borderColor">
  {{ text }}
</div>
